export const RECORD_TYPES = {
    product: 'product',
    variant: 'variant',
}
